import React, { useEffect, useState } from "react";
import { msg_crm, search_icon } from "../../assets/imgs";
import Property from "../../components/Notifications/Property";
import Registration from "../../components/Notifications/Registration";
import MMc from "../../components/Notifications/MMc";
import Others from "../../components/Notifications/Others";
import Suspended from "../../components/Notifications/Suspended";
import { Col, Pagination, Row, Spinner } from "react-bootstrap";

import moment from "moment";
import { Today } from "@mui/icons-material";

const Notification = () => {
  const [tabs, setTabs] = useState(1);
  const [propertyList, setPropertyList] = useState([]);
  const [reviewList, setReviewList] = useState([]);
  const [suspendedList, setSuspendedList] = useState([]);
  const [mmcList, setMmcList] = useState([]);
  const [othersList, setOthersList] = useState([]);
  const [fromdate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [search, setSearch] = useState("");
  const [type, setType] = useState("");

  const [pagecount, setPagecount] = useState(10)
  const [pageno, setPageno] = useState(1)

  const [loader, setLoader] = useState(false);



  return (
    <div className="dashRightView home_section">
      <div className="d-flex ac-jb">
        <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec ">
          Notification
        </h2>
        {/* <div className="d-flex gap-3 ac-je">
          <label className="f2 fs-sm-8 fs-md-14 fs-lg-16 fs-xl-16 fs-xxl-18 primary ">
            From Date
          </label>
          <div className="w-15">
            <DatePicker
              selected={fromdate}
              onChange={(e) =>
                notificationList(pageno, e, toDate, search)
              }
              dateFormat="dd-MM-yyyy"
              className="input-pop-new ps-2 w-100"
              placeholderText="From Date"
              type="date"
            />
          </div>
          <label className="f2 fs-sm-8 fs-md-14 fs-lg-16 fs-xl-16 fs-xxl-18 primary ">
            To Date
          </label>
          <div className="w-15">
            <DatePicker
              selected={toDate}
              onChange={(e) =>
                notificationList(pageno, fromdate, e, search)
              }
              dateFormat="dd-MM-yyyy"
              className="input-pop-new ps-2 w-100"
              placeholderText="To Date"
              type="date"
            />
          </div>
          <div className="search-input">
            <input onChange={(e) => notificationList(pageno, fromdate, toDate, e.target.value)}
              type="text"
              placeholder="Search"
              style={{ border: "none", width: "150px" }}
            />
            <img src={search_icon} className="search" />
          </div>
        </div> */}
      </div>
      <div className="d-flex gap-4 mt-3">
        <h2
          onClick={() => {
            setTabs(1);
          }}
          className={`${tabs == 1 ? "active_tabs" : ""
            } f3 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`}
        >
          Property
        </h2>
        {/* <h2
          onClick={() => {
            setTabs(2);
          }}
          className={`${tabs == 2 ? "active_tabs" : ""
            } f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`}
        >
          Review
        </h2> */}
        <h2
          onClick={() => {
            setTabs(2);
          }}
          className={`${tabs == 2 ? "active_tabs" : ""
            } f3 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`}
        >
          Suspended
        </h2>
        <h2
          onClick={() => {
            setTabs(3);
          }}
          className={`${tabs == 3 ? "active_tabs" : ""
            } f3 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`}
        >
          MMC
        </h2>
        <h2
          onClick={() => {
            setTabs(4);
          }}
          className={`${tabs == 4 ? "active_tabs" : ""
            } f3 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`}
        >
          Others
        </h2>
      </div>
      {loader && (<div style={{ zIndex: 2000, position: "fixed", top: "45%", left: "49%", }}  >
        <Spinner animation="border" className="primary1" />
      </div>
      )}

      {tabs == 1 && <Property fromdate={fromdate} toDate={toDate} search={search} propertyList={propertyList}  />}
      {/* {tabs == 2 && <Registration reviewList={reviewList} />} */}
      {tabs == 2 && <Suspended suspendedList={suspendedList} />}
      {tabs == 3 && <MMc mmcList={mmcList} />}
      {tabs == 4 && <Others othersList={othersList} />}




    
    </div>
  );
};

export default Notification;
